<template>
  <div
    class="text-with-svg-icon"
    :class="`text-with-svg-icon--icon-${iconPosition}`"
  >
    <div
      class="text-with-svg-icon__icon"
      :class="{ 'text-with-svg-icon__icon--background': iconBackground }"
      aria-hidden="true"
    >
      <slot name="icon" />
    </div>
    <a
      v-if="link"
      :href="link"
      :target="target"
      :style="{ textAlign: effectiveTextAlign }"
      class="text-with-svg-icon__link"
    >
      <slot name="text" />
    </a>
    <c-text
      v-else
      :color="textColor"
      :size="textSize"
      :weight="textWeight"
      :align="effectiveTextAlign"
      class="text-with-svg-icon__text"
    >
      <slot name="text" />
    </c-text>
  </div>
</template>

<script>

import CText from '@atoms/text/text.vue'

export default {
  name: 'text-with-svg-icon',
  components: { CText },
  props: {
    iconSize: {
      type: String,
      default: '24px',
    },
    iconColor: {
      type: String,
      default: '#43515A',
    },
    iconPosition: {
      type: String,
      default: 'left',
    },
    iconBackground: {
      type: Boolean,
      default: false,
    },
    iconBackgroundColor: {
      type: String,
      default: '#EDF2F5',
    },
    iconBackgroundRadius: {
      type: String,
      default: '50%',
    },
    iconAlign: {
      type: String,
      default: 'middle',
    },
    iconTextGap: {
      type: String,
      default: '0.5rem',
    },
    textColor: {
      type: String,
      default: '#43515A',
    },
    textSize: {
      type: String,
      default: 'lg',
    },
    textWeight: {
      type: String,
      default: '400',
    },
    textAlign: {
      type: String,
      default: 'left',
    },
    link: {
      type: String,
    },
    target: {
      type: String,
      default: undefined,
    }
  },
  computed: {
    iconAlignItems() {
      if (this.iconPosition === 'top' || this.iconPosition === 'bottom') {
        return 'center'
      }

      return { top: 'flex-start', middle: 'center', bottom: 'flex-end' }[this.iconAlign]
    },
    effectiveTextAlign() {
      if (this.iconPosition === 'top' || this.iconPosition === 'bottom') {
        return 'center'
      }

      return this.textAlign
    },
  },
}
</script>

<style lang="scss" scoped>
.text-with-svg-icon {
  display: flex;
  width: 100%;
  flex-direction: row;
  gap: v-bind(iconTextGap);

  &--icon-right {
    flex-direction: row-reverse;
  }

  &--icon-top {
    flex-direction: column;
    align-items: center;
  }

  &--icon-bottom {
    flex-direction: column-reverse;
    align-items: center;
  }

  &__icon {
    display: inline-flex;
    align-self: v-bind(iconAlignItems);
    color: v-bind(iconColor);

    &--background {
      align-items: center;
      justify-content: center;
      border-radius: v-bind(iconBackgroundRadius);
      background-color: v-bind(iconBackgroundColor);
      padding: calc(v-bind(iconSize) / 2);
    }

    :deep(svg) {
      width: v-bind(iconSize);
      height: v-bind(iconSize);
    }

    :deep(svg),
    :deep(svg *) {
      stroke: currentColor !important;
    }

    :deep(svg:not([fill='none'])){
      fill: currentColor !important;
    }
  }

  &__text {
    color: $neutral-02;
    line-height: 150%;
    letter-spacing: -0.01em;
    display: block !important;
    flex-grow: 1;
  }

  &__link {
    @include font-inter(400);
    @extend .text-with-svg-icon__text;
    text-decoration: underline;
    cursor: pointer;
    color: v-bind(textColor);
  }
}
</style>
